<template>
  <div class="login-bg">
    <w-app
      id="app"
      class="justify-space-between basis-zero justify-center align-center login-bg"
    >
      <header></header>

      <main class="grow align-self-center mt-12">
        <w-card class="zloginbox-title">
          <div class="zloginbox-title-top">iHasil</div>
          <div class="zloginbox-title-bottom">
            Daftar Masuk ke Sistem iHasil
          </div>
        </w-card>

        <w-card class="zloginbox2">
          <w-alert
            class="my0 mb2 text-light"
            v-if="$page.props.flash.errors"
            error
            transition="bounce"
            plain
            round
            no-border
            dismiss
          >
            {{ $page.props.flash.errors }}
          </w-alert>

          <w-alert
            class="my0 mb2 text-light"
            v-if="salah"
            error
            timeout="2"
            transition="bounce"
            plain
            round
            no-border
            dismiss
          >
            {{ salah }}
          </w-alert>

          <w-alert
            class="my0 mb2 text-light"
            v-if="success"
            success
            transition="bounce"
            plain
            round
            no-border
            dismiss
          >
            {{ success }}
          </w-alert>

          <w-notification
            v-if="$page.props.flash.success"
            success
            transition="bounce"
            absolute
            plain
            round
            timeout="8000"
            @close="$page.props.flash.success = ''"
          >
            {{ $page.props.flash.success }}
          </w-notification>

          <w-notification
            v-if="$page.props.flash.notifyerror"
            error
            transition="bounce"
            absolute
            plain
            round
            timeout="2000"
            @close="$page.props.flash.notifyerror = ''"
          >
            {{ $page.props.flash.notifyerror }}
          </w-notification>

          <!-- <template #buttons /> -->

          <w-form @validate="attemp">
            <w-input
              outline
              label="Nama"
              type="text"
              placeholder="Sila Masukkan Nama"
              name="name"
              v-model="form.name"
              :validators="[validators.required]"
            />
            <!-- <div class="spacer"></div>
             <w-flex justify-space-between class="mb4 mt3">
              <z-lookup label="Jenis Pengenalan" name="pengenalan" :url='service_utiliti+"api/lookup/pengenalan"' :sort="false" :cache="false" v-model="form.lkp_pengenalan_id" :validators="[validators.required]"/>
            </w-flex> -->
            <div class="spacer"></div>
            <w-input
              outline
              label="No. Kad Pengenalan"
              class="mt3"
              type="text"
              placeholder="Sila Masukkan No. Kad Pengenalan"
              name="no_id"
              v-model="form.no_id"
              :validators="[validators.required]"
            />
            <template v-if="no_id_wujud">
              <div style="color: red">
                {{ no_id_wujud }}
              </div>
            </template>
            <div class="spacer"></div>

            <w-input
              outline
              label="Emel"
              class="mt3"
              type="email"
              placeholder="Sila Masukkan Emel"
              name="email"
              v-model="form.email"
              :validators="[validators.required, validators.email]"
            />

            <template v-if="email_wujud">
              <div style="color: red">
                {{ email_wujud }}
              </div>
            </template>
            <!-- <w-tooltip
                            right
                            align-bottom
                            color="white"
                            bg-color="blue"
                        >
                            <template #activator="{ on }">
                                <span v-on="on">
                        <w-input
                            outline
                            label="Emel"
                            class="mt3"
                            type="email"
                            placeholder="Sila Masukkan Emel"
                            name="email"
                            v-model="form.email"
                            :validators="[
                                validators.required,
                                validators.email,
                            ]"
                        />
                        </span>
                        </template>
                           Sila pastikan format domain emel dalam bentuk example@gov.my
                        </w-tooltip>
                        <template v-if="email_wujud">
                            <div style="color: red">
                                {{ email_wujud }}
                            </div>
                        </template> -->
            <div class="spacer"></div>

            <w-input
              outline
              label="Sahkan Emel"
              class="mt3"
              type="email"
              placeholder="Sila Sahkan Emel"
              name="email"
              v-model="form.email_confirmation"
              :validators="[validators.required, validators.email]"
            />

            <template v-if="form.email != form.email_confirmation">
              <div style="color: red; font-size: 10px">
                Emel Tidak Sepadan
              </div></template
            >
            <template v-if="email_wujud">
              <div style="color: red">
                {{ email_wujud }}
              </div>
            </template>
            <div class="spacer"></div>
            <w-input
              outline
              label="Nombor Telefon"
              class="mt3"
              type="tel"
              placeholder="Sila Masukkan Nombor Telefon"
              name="phone_number"
              v-model="form.phone_number"
              :validators="[validators.required, validators.numeric]"
            />
            <div class="spacer"></div>
            <w-input
              outline
              label="Jawatan"
              class="mt3"
              type="text"
              placeholder="Sila Masukkan Jawatan"
              name="jawatan"
              v-model="form.jawatan"
              :validators="[validators.required]"
            />
            <w-tooltip right align-bottom color="white" bg-color="blue">
              <template #activator="{ on }">
                <span v-on="on">
                  <div class="spacer"></div>
                  <w-input
                    outline
                    label="Kata Laluan "
                    class="mt3"
                    placeholder="Sila Masukkan Kata Laluan"
                    :type="isPassword ? 'password' : 'text'"
                    :inner-icon-right="
                      isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'
                    "
                    @click:inner-icon-right="isPassword = !isPassword"
                    name="password"
                    v-model="form.password"
                    :validators="[
                      validators.required,
                      validators.regex,
                      validators.min8,
                    ]"
                  />
                </span>
              </template>
              Medan Ini Wajib mempunyai huruf besar, huruf kecil, nombor, simbol
              dan minimum 8 aksara
            </w-tooltip>
            <w-tooltip right align-bottom color="white" bg-color="blue">
              <template #activator="{ on }">
                <span v-on="on">
                  <w-input
                    outline
                    label="Sahkan Kata Laluan"
                    class="mt3"
                    placeholder="Sila Sahkan Kata Laluan"
                    :type="isPassword1 ? 'password' : 'text'"
                    :inner-icon-right="
                      isPassword1 ? 'fal fa-eye-slash' : 'fal fa-eye'
                    "
                    @click:inner-icon-right="isPassword1 = !isPassword1"
                    name="password_confirmation"
                    v-model="form.password_confirmation"
                    :validators="[
                      validators.required,
                      validators.regex,
                      validators.min8,
                    ]"
                  />
                </span>
              </template>
              Medan Ini Wajib mempunyai huruf besar, huruf kecil, nombor, simbol
              dan minimum 8 aksara
            </w-tooltip>

            <template v-if="form.password != form.password_confirmation">
              <div style="color: red; font-size: 10px">
                Kata Laluan tidak sepadan
              </div></template
            >

            <div class="spacer"></div>
            <z-lookup
              class="mt3"
              style="margin-left: 10px"
              label="Jabatan"
              name="jabatan"
              placeholder="Sila Pilih Jabatan"
              :url="service_utiliti + 'lookup/jabatan'"
              :sort="false"
              :cache="false"
              v-model="form.jabatan_id"
              :validators="[validators.required]"
            />

            <div class="spacer"></div>

            <w-input
              class="mt3"
              style="margin-left: 10px"
              type="file"
              placeholder="Sila Muatnaik Borang Permohonan"
              required
              v-model="files"
              label="Borang Permohonan"
            />
            <div class="spacer"></div>

            <w-input
              style="margin-left: 10px"
              type="file"
              placeholder="Sila Muatnaik Salinan Kad Pengenalan"
              required
              v-model="files_ic"
              label="Salinan Kad Pengenalan"
            />

            <w-flex justify-center align-center class="mt5">
              <!--
                    <w-button
                      class="my1 mr2"
                      bg-color="warning"
                      type="reset">
                      Reset
                    </w-button>
                    -->

              <w-button class="my2 btn-zloginbox grow" type="submit">
                <w-icon class="mr2" xs>fal fa-sign-in-alt</w-icon>
                Daftar
              </w-button>
            </w-flex>
          </w-form>
          <w-flex justify-center align-center>
            <w-button
              bg-color="grey-light5--bg"
              class="my2 btn-zloginboxback grow"
              type=""
              @click="back()"
            >
              <w-icon class="mr2" xs>fal fa-arrow-left</w-icon>
              Kembali
            </w-button>
          </w-flex>
        </w-card>

        <div class="zloginbox-title-footer">
          <b>#HAK CIPTA TERPELIHARA © 2022 KERAJAAN NEGERI KEDAH</b>
        </div>
      </main>

      <footer></footer>
    </w-app>
  </div>
</template>

<script>
import ZResource from "@/Modules/z-resource";

export default {
  extends: ZResource,
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      isPassword: true,
      isPassword1: true,
      resourceurl: "register",
      success: "",
      error: "",
      email_wujud: "",
      no_id_wujud: "",
      salah: "",
      files: [],
      files_ic: [],

      form: {
        errorsCount: 0,
        name: "",
        // lkp_pengenalan_id: '',
        no_id: "",
        email: "",
        phone_number: "",
        jawatan: "",
        password: "",
        password_confirmation: "",
        email_confirmation: "",
        jabatan_id: "",
      },
    };
  },
  methods: {
    back() {
      window.history.back();
    },

    attemp() {
      //  // if (this.$refs.form.validate()) {
      // this.dialog.loading = true

      if (this.form.id > 0) {
        this.$zcomm
          .update(this.resourceurl + ".update", this.form.id, this.form)
          .then((res) => {
            //update displayed record
            this.mapreturneddata(res);
            this.dialog.show = false;
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit();
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.dialog.loading = false;
            // this.dialog.show = false
          });
      } else {
        this.upload();
        if (this.form.email == this.form.email_confirmation) {
          if (this.form.password == this.form.password_confirmation) {
            if (this.files.length && this.files_ic.length > 0) {
              this.$zcomm
                .addRegister(this.resourceurl + ".store", this.form)
                .then((res) => {
                  this.mapreturneddata(res);
                  // this.dialog.show = false;
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd();
                  }
                  // this.upload();
                  this.upload(res.id);
                })
                .catch((err) => {
                  this.notify("Terdapat Ralat Dalam Memproses Input Anda", 0);
                  // alert('slahh ni');
                  if (
                    err.response.data.errors.email ==
                    "The email has already been taken."
                  ) {
                    this.email_wujud = "Emel sudah wujud";
                  }
                  if (
                    err.response.data.errors.no_id ==
                    "The no id has already been taken."
                  ) {
                    this.no_id_wujud = "No id sudah wujud";
                  }
                })

                .finally(() => {
                  this.dialog.loading = false;

                  // $('#' + this.resourceurl).modal('hide')
                });
            } else {
              alert(
                "Sila Muatnaik Borang Permohonan Dan Salinan Kad Pengenalan"
              );
            }
          } else {
            alert("Kata Laluan tidak sepadan");
          }
        } else {
          alert("Emel Tidak Sepadan");
        }
      }
    },
    // }
    // this.$inertia.post('register',this.form)

    upload(id) {
      let formData = new FormData();
      formData.append("file", this.files[0].file);
      formData.append("file_ic", this.files_ic[0].file);
      formData.append("model", "App\\Models\\User");
      formData.append("email", this.form.email);
      this.$zcomm
        .post(this.resourceurl + ".upload", formData)
        .then((res) => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd();
          }
          //   this.$zutil.notify ("Aduan Telah Berjaya Dihantar")
        })
        .catch((err) => {})
        .finally(() => {});
    },
    notify(msg, success = true) {
      if (success) this.success = msg;
      else this.salah = msg;
    },
  },
};
</script>

<style>
#app {
  flex-direction: column;
}
.login-bg {
  /* background: url(/images/landpage.jpg) !important; */
  background-size: cover !important;
  background-repeat: no-repeat !important;
}
.zloginbox {
  width: 100%;
  background: inherit !important;
}
.zloginbox2 {
  background: inherit !important;
}
.zloginbox2 .w-card__content {
  background: #fff;
}
.zloginbox .w-card__content {
  background: #fff;
}
.zloginbox .w-toolbar {
  background-color: #0c213ab8;
  color: #fff;
}
.zloginbox .w-input__input-wrap {
  margin-top: 25px;
}
.zloginbox .w-input__label--inside {
  font-size: 15px;
  /* margin-top: -5px; */
  margin-left: -5px;
}
.zloginbox .w-input__input-wrap--box {
  height: 33px;
}
.zloginbox .w-card__content {
  padding: 16px;
  width: 100% !important;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
}
.w-card.zloginbox-title {
  background: #0c213ab8;
  color: #fff;
  text-align: center;
  background: #3d272ab0;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  border-top: 1px solid #8c6c68;
  border-left: 1px solid #8c6c68;
  border-right: 1px solid #8c6c68;
  margin-top: 150px;
}
.zloginbox-title-top {
  font-weight: bold;
  font-size: 15px;
  text-shadow: 1px 1px black;
}
.zloginbox-title-bottom {
  margin-bottom: 10px;
  margin-top: 5px;
}
.zloginbox-logo img {
  height: 100px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-zloginbox {
  color: #fff;
  background-color: #1761fd !important;
  border-color: #1761fd !important;
  font-size: 13px !important;
  padding: 15px;
}
.btn-zloginboxback {
  color: rgb(8, 1, 1);
  border-color: #0000001a !important;
  font-size: 13px !important;
  padding: 15px;
}
.zloginbox-title-footer {
  text-align: center;
  font-size: 13px;
  color: #fff;
  margin-top: 10px;
  text-shadow: 1px 1px black;
}
</style>
